<template>
	<div class="gb-page">
		<HeadNav
			selectedLanguage="en"
			page="gb" />

		<main>
			<section class="hero-section">
				<div class="page-shell hero-layout">
					<div class="hero-copy">
						<p class="hero-eyebrow">
							Latest Release
						</p>
						<h1>GB WhatsApp APK v18.80</h1>
						<h2 class="hero-subtitle">Download Latest Version 2026 (Anti-Ban)</h2>
						<p>Download the latest GB WhatsApp APK for Android with more privacy, customization, and messaging features.</p>
						<div class="hero-actions">
							<router-link
								class="primary-btn"
								:to="{ name: 'en-download' }">
								<img
									class="btn-icon"
									:src="downIcon"
									alt="">
								DOWNLOAD GB WHATSAPP APK
							</router-link>
							<div
								class="hero-badges"
								aria-label="GB WhatsApp highlights">
								<span
									v-for="badge in heroBadges"
									:key="badge.title"
									class="hero-badge">
									<span
										class="hero-badge-icon"
										:class="`hero-icon-${badge.icon}`">
										<svg
											v-if="badge.icon === 'android'"
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M7.2 8.3h9.6v7.9c0 .8-.6 1.4-1.4 1.4h-.7v2.2c0 .6-.4 1-1 1s-1-.4-1-1v-2.2h-1.4v2.2c0 .6-.4 1-1 1s-1-.4-1-1v-2.2h-.7c-.8 0-1.4-.6-1.4-1.4V8.3Zm-2 1.2c.6 0 1 .4 1 1v4.2c0 .6-.4 1-1 1s-1-.4-1-1v-4.2c0-.6.4-1 1-1Zm13.6 0c.6 0 1 .4 1 1v4.2c0 .6-.4 1-1 1s-1-.4-1-1v-4.2c0-.6.4-1 1-1ZM8.4 4.6 7.3 2.7l1-.5 1.1 1.9c.8-.3 1.7-.4 2.6-.4s1.8.1 2.6.4l1.1-1.9 1 .5-1.1 1.9c1.2.7 2 1.8 2 3H6.4c0-1.2.8-2.3 2-3Zm1.4 1.5c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7Zm4.4 0c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7Z" />
										</svg>
										<svg
											v-else-if="badge.icon === 'shield'"
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M12 2.4 19.5 5v5.7c0 4.7-3 8.9-7.5 10.9-4.5-2-7.5-6.2-7.5-10.9V5L12 2.4Zm0 2.3L6.6 6.6v4.1c0 3.4 2.1 6.7 5.4 8.5 3.3-1.8 5.4-5.1 5.4-8.5V6.6L12 4.7Zm3.9 5.1-4.5 4.7-2.5-2.4 1.3-1.4 1.2 1.2 3.2-3.4 1.3 1.3Z" />
										</svg>
										<svg
											v-else-if="badge.icon === 'refresh'"
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M19.5 7.9V3.5h2v8h-8v-2h4.7A7.1 7.1 0 0 0 5 8.2L3.5 6.8a9.1 9.1 0 0 1 16 .9Zm-15 8.2v4.4h-2v-8h8v2H5.8A7.1 7.1 0 0 0 19 15.8l1.5 1.4a9.1 9.1 0 0 1-16-.9Z" />
										</svg>
										<svg
											v-else
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M7.5 10V7.7a4.5 4.5 0 0 1 9 0V10H18c.8 0 1.5.7 1.5 1.5v8c0 .8-.7 1.5-1.5 1.5H6c-.8 0-1.5-.7-1.5-1.5v-8c0-.8.7-1.5 1.5-1.5h1.5Zm2 0h5V7.7a2.5 2.5 0 0 0-5 0V10Zm2.5 3.5a1.5 1.5 0 0 0-.8 2.8v1.6h1.6v-1.6a1.5 1.5 0 0 0-.8-2.8Z" />
										</svg>
									</span>
									<span>
										<strong>{{ badge.title }}</strong>
										<small>{{ badge.text }}</small>
									</span>
								</span>
							</div>
						</div>
					</div>
					<div
						class="hero-visual"
						aria-hidden="true">
						<div class="hero-image-wrap">
							<div class="hero-phone-panel">
								<img
									class="hero-phone-image"
									:src="heroImage"
									alt="">
							</div>
							<div class="hero-stats">
								<div
									v-for="stat in heroStats"
									:key="stat.label"
									class="hero-stat-card">
									<span class="hero-stat-icon">
										<svg
											v-if="stat.icon === 'download'"
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M11 3h2v9.2l3.3-3.3 1.4 1.4L12 16l-5.7-5.7 1.4-1.4 3.3 3.3V3Zm-6 14h2v2h10v-2h2v3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-3Z" />
										</svg>
										<svg
											v-else-if="stat.icon === 'calendar'"
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M7 2h2v2h6V2h2v2h2.5C20.3 4 21 4.7 21 5.5v14c0 .8-.7 1.5-1.5 1.5h-15C3.7 21 3 20.3 3 19.5v-14C3 4.7 3.7 4 4.5 4H7V2Zm12 7H5v10h14V9ZM7 11h3v3H7v-3Zm5 0h3v3h-3v-3Zm-5 5h3v2H7v-2Zm5 0h5v2h-5v-2Z" />
										</svg>
										<svg
											v-else
											viewBox="0 0 24 24"
											aria-hidden="true">
											<path d="M8 2h8c.9 0 1.7.8 1.7 1.7v16.6c0 .9-.8 1.7-1.7 1.7H8c-.9 0-1.7-.8-1.7-1.7V3.7C6.3 2.8 7.1 2 8 2Zm.3 3v13.8h7.4V5H8.3Zm2.6 14.7v.8h2.2v-.8h-2.2Z" />
										</svg>
									</span>
									<span class="hero-stat-text">
										<span>{{ stat.label }}</span>
										<strong>{{ stat.value }}</strong>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="hero-intro-section">
				<div class="page-shell hero-intro">
					<p><strong>GB WhatsApp</strong> gives Android users a different way to use WhatsApp, with more control over the interface, privacy preferences, and everyday chat settings. Its available options can vary between releases, so users may notice differences in appearance and settings depending on the version installed.</p>
					<p><strong>Disclaimer:</strong> GB WhatsApp is a third-party modification and is not affiliated with or endorsed by WhatsApp or Meta.</p>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell">
					<h2>GB WhatsApp APK Information</h2>
					<div class="table-wrap">
						<table>
							<thead>
								<tr>
									<th>Information</th>
									<th>Details</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="row in apkInformationRows"
									:key="row[0]">
									<td>{{ row[0] }}</td>
									<td>
										<router-link
											v-if="row[0] === 'App Name'"
											:to="{ name: 'en-gb' }">
											{{ row[1] }}
										</router-link>
										<template v-else>
											{{ row[1] }}
										</template>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<p>Before installing GB WhatsApp APK, make sure your Android device has enough storage space and allows APK installation from your browser or file manager. Always check the downloaded file before opening it on your device.</p>
					<p>GB WhatsApp is available as an Android APK file. Users can download the latest version and follow the installation steps below to set up the app.</p>
				</div>
			</section>

			<section class="content-section muted">
				<div class="page-shell overview-layout">
					<div
						class="overview-visual"
						aria-hidden="true">
						<img
							:src="overviewImage"
							alt="">
					</div>
					<div>
						<h2>What Is GB WhatsApp?</h2>
						<p>
							GB WhatsApp is
							<strong>a modified version of WhatsApp</strong>
							that provides additional
							<strong>customization options and extra settings</strong>
							compared with the original WhatsApp.
						</p>
						<p>It is available as an Android APK file and is commonly used by people who want more control over their messaging app appearance, privacy preferences, and chat customization.</p>
						<p>GB WhatsApp includes options such as changing themes, adjusting chat styles, managing privacy settings, and customizing the way messages and media are displayed.</p>
						<p>Users should understand how APK files work and check app sources before installation. Different GB WhatsApp versions may include different features. Some options can change depending on the developer release and Android version.</p>
						<p>GB WhatsApp gives Android users a different way to use WhatsApp, with more control over the interface, privacy preferences, and everyday chat settings. Its available options can vary between releases, so users may notice differences in appearance and settings depending on the version installed.</p>
						<p>
							<strong>Disclaimer:</strong>
							GB WhatsApp is a third-party modification and is not affiliated with or endorsed by WhatsApp or Meta.
						</p>
					</div>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell compat-layout">
					<div
						class="compat-visual"
						aria-hidden="true">
						<img
							:src="androidImage"
							alt="">
					</div>
					<div>
						<h2>GB WhatsApp Compatibility</h2>
						<p>GB WhatsApp APK is designed for Android devices. Before installation, check your device requirements.</p>
						<div class="table-wrap">
							<table>
								<thead>
									<tr>
										<th>Requirement</th>
										<th>Details</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="row in compatibilityRows"
										:key="row[0]">
										<td>{{ row[0] }}</td>
										<td>{{ row[1] }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</section>

			<section class="content-section install-section">
				<div class="page-shell">
					<div class="install-header">
						<h2>How to Download and Install GB WhatsApp</h2>
						<p>Installing GB WhatsApp APK is similar to installing other Android APK files. Follow these simple steps to download the file, allow installation, and complete the setup.</p>
					</div>

					<div class="install-timeline">
						<article class="install-step step-1">
							<div class="step-marker">
								<span
									class="step-num"
									aria-hidden="true">
									01
								</span>
							</div>
							<div class="install-card">
								<h3>Download GB WhatsApp APK File</h3>
								<p>First, click the download button on this page to get the latest GB WhatsApp APK file.</p>
								<p>After downloading:</p>
								<ul>
									<li>Save the APK file on your Android device.</li>
									<li>Open your download folder and find the APK file.</li>
									<li>Check the file name and size before installation.</li>
									<li>Make sure the download process is complete.</li>
								</ul>
								<p>If the APK file is incomplete or damaged, the installation may not work correctly. Downloading the latest version can help you get updated features and improvements.</p>
							</div>
						</article>

						<article class="install-step step-2">
							<div class="step-marker">
								<span
									class="step-num"
									aria-hidden="true">
									02
								</span>
							</div>
							<div class="install-card">
								<h3>Enable Unknown Sources</h3>
								<p>Android blocks APK installations from unknown sources by default for security reasons. You need to allow this option before installing GB WhatsApp.</p>
								<p>To enable APK installation:</p>
								<ol>
									<li>Open your Android Settings.</li>
									<li>Go to Security or Apps settings.</li>
									<li>Find the option for installing unknown apps.</li>
									<li>Allow permission for your browser or file manager.</li>
								</ol>
								<p>The exact menu name may be different depending on your Android version and device brand.</p>
							</div>
						</article>

						<article class="install-step step-3">
							<div class="step-marker">
								<span
									class="step-num"
									aria-hidden="true">
									03
								</span>
							</div>
							<div class="install-card">
								<h3>Install and Set Up GB WhatsApp</h3>
								<p>After enabling APK installation:</p>
								<ol>
									<li>Open the downloaded GB WhatsApp APK file.</li>
									<li>Tap Install and wait for the process to finish.</li>
									<li>Open GB WhatsApp after installation.</li>
									<li>Enter your phone number and complete the setup process.</li>
								</ol>
								<p>Users who want to keep existing chats should create a backup before changing apps. The available restore options may depend on the WhatsApp version and device settings.</p>
							</div>
						</article>
					</div>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell">
					<h2>GB WhatsApp Features</h2>
					<p>GB WhatsApp includes options for users who want more customization and control over their messaging experience. Available features may vary between versions.</p>
					<p>The following feature cards show some popular options found in different GB WhatsApp versions.</p>
					<div class="features-grid">
						<article
							v-for="feature in featureRows"
							:key="feature.title"
							class="feature-card">
							<span
								class="feature-mark"
								:class="feature.icon"
								aria-hidden="true">
								{{ feature.mark }}
							</span>
							<h3>{{ feature.title }}</h3>
							<p>{{ feature.text }}</p>
						</article>
					</div>
				</div>
			</section>

			<section class="content-section muted">
				<div class="page-shell">
					<h2>GB WhatsApp vs Official WhatsApp</h2>
					<p>GB WhatsApp is a modified version of WhatsApp that adds extra customization options. The table below shows some common differences between GB WhatsApp and the official WhatsApp.</p>
					<div class="table-wrap comparison-table">
						<table>
							<thead>
								<tr>
									<th>Feature</th>
									<th>GB WhatsApp</th>
									<th>Official WhatsApp</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="row in comparisonRows"
									:key="row[0]">
									<td>{{ row[0] }}</td>
									<td>{{ row[1] }}</td>
									<td>{{ row[2] }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell">
					<div class="download-box">
						<h2>Download GB WhatsApp APK Latest Version</h2>
						<p>Ready to install GB WhatsApp on your Android device?</p>
						<p>Download the latest GB WhatsApp APK version and follow our installation guide to complete the setup.</p>
						<router-link
							class="primary-btn"
							:to="{ name: 'en-download' }">
							<img
								class="btn-icon"
								:src="downIcon"
								alt="">
							Download GB WhatsApp APK
						</router-link>
					</div>
				</div>
			</section>

			<section class="content-section muted">
				<div class="page-shell">
					<h2>GB WhatsApp Latest Version Updates</h2>
					<p>Keeping GB WhatsApp updated helps users access newer options, improvements, and changes included in recent releases. Each version may introduce different updates depending on the developer release.</p>
					<p>Before installing a new version, users should check the version information and make sure their device supports the APK requirements.</p>

					<div class="update-card">
						<h2>New Features in Latest Version v18.80</h2>
						<p>The latest GB WhatsApp versions may include:</p>
						<ul>
							<li>New customization options</li>
							<li>Updated themes and interface changes</li>
							<li>Bug fixes and performance improvements</li>
							<li>Additional privacy settings</li>
							<li>Changes to media and chat options</li>
						</ul>
						<p>New releases can be different from previous versions. Some features may be updated, removed, or changed based on the version available.</p>
						<p>Users who already have GB WhatsApp installed should create a backup before updating. This can help protect important chat data during the update process.</p>
						<p>You can download the latest GB WhatsApp APK from this page and follow the installation steps to update your app.</p>
					</div>

					<h2>Previous GB WhatsApp Versions</h2>
					<p>Some users may need older GB WhatsApp versions because of device compatibility or personal preferences.</p>
					<p>Our old versions section provides information about previous releases, including:</p>
					<ul>
						<li>Earlier GB WhatsApp APK versions</li>
						<li>Version numbers</li>
						<li>File details</li>
						<li>Update history</li>
					</ul>
					<h3>GB WhatsApp Version History</h3>
					<div class="table-wrap">
						<table>
							<thead>
								<tr>
									<th>Version</th>
									<th>Release</th>
									<th>File Size</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="row in versionHistoryRows"
									:key="row[0]">
									<td>{{ row[0] }}</td>
									<td>{{ row[1] }}</td>
									<td>{{ row[2] }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell">
					<h2>Is GB WhatsApp Safe and Secure?</h2>
					<p>GB WhatsApp is a third-party modification, so it does not receive the same official support and security review as the original WhatsApp app. The main risks include downloading a modified APK, privacy concerns, compatibility issues, and possible account restrictions.</p>
					<p>If you decide to use GB WhatsApp, check the APK source carefully, avoid modified files from unknown websites, and keep important chat data backed up. Also remember that no unofficial WhatsApp version can guarantee complete security or prevent account restrictions.</p>
					<p>
						For the APK provided on this site, we regularly check the file with VirusTotal, and
						<strong>the current APK shows no detections in the scan results</strong>
						. Users can also independently upload the downloaded APK to VirusTotal for an additional security check before installation.
					</p>
				</div>
			</section>

			<section class="content-section muted">
				<div class="page-shell problem-content">
					<h2>Common GB WhatsApp APK Problems</h2>
					<h3>Why Is GB WhatsApp Not Working?</h3>
					<p>If GB WhatsApp is not working, try these fixes in order:</p>
					<ol>
						<li>
							<strong>Restart GB WhatsApp</strong>
							and your Android phone.
						</li>
						<li>
							<strong>Check your internet connection</strong>
							by switching between Wi-Fi and mobile data.
						</li>
						<li>
							Go to
							<strong>Settings -&gt; Apps -&gt; GB WhatsApp -&gt; Storage</strong>
							and tap
							<strong>Clear Cache</strong>
							.
						</li>
						<li>Check that GB WhatsApp has the required permissions.</li>
						<li>If the problem started after an update, check whether a newer compatible version is available.</li>
					</ol>
					<p>Avoid clearing app data unless your important chats have been backed up.</p>

					<h3>Why Is GB WhatsApp Verification Not Working?</h3>
					<p>If you cannot verify your phone number:</p>
					<ol>
						<li>
							Check that your
							<strong>phone number and country code are correct</strong>
							.
						</li>
						<li>
							Make sure your SIM can receive
							<strong>SMS messages and calls</strong>
							.
						</li>
						<li>Switch to a stable mobile network and request the code again.</li>
						<li>
							If you requested too many codes,
							<strong>wait before trying again</strong>
							.
						</li>
						<li>
							If SMS verification fails, use the
							<strong>call verification</strong>
							option when available.
						</li>
					</ol>
					<p>Never share your verification code with anyone.</p>

					<h3>Can a GB WhatsApp Ban Be Reversed?</h3>
					<p>If your GB WhatsApp account has been restricted, the available solution depends on the type of restriction.</p>
					<ul>
						<li>
							<strong>Temporary ban:</strong>
							Wait until the countdown ends and follow the instructions shown by WhatsApp.
						</li>
						<li>
							<strong>Account review available:</strong>
							Submit a review through the official WhatsApp process.
						</li>
						<li>
							<strong>Permanent ban:</strong>
							There is no guaranteed third-party method to reverse it. Avoid websites or apps claiming they can instantly unban your number.
						</li>
					</ul>
					<p>If you regain access, switching to the official WhatsApp app can reduce the risk of further restrictions.</p>

					<h3>GB WhatsApp Linked Devices: What You Need to Know</h3>
					<p>If you cannot link GB WhatsApp to another device, try these steps:</p>
					<ol>
						<li>
							Open GB WhatsApp and go to
							<strong>Linked Devices</strong>
							.
						</li>
						<li>
							Tap
							<strong>Link a Device</strong>
							.
						</li>
						<li>Open the linking screen on the other device.</li>
						<li>
							Scan the displayed
							<strong>QR code</strong>
							.
						</li>
						<li>Keep both devices connected to a stable internet connection during the process.</li>
					</ol>
					<p>If the QR code does not work, close and reopen the linking screen and scan a newly generated code. If the device keeps disconnecting, check whether your GB WhatsApp version supports the linking method you are using.</p>
				</div>
			</section>

			<section class="content-section">
				<div class="page-shell">
					<h2>FAQ</h2>
					<div class="faq-list">
						<details
							v-for="faq in faqRows"
							:key="faq[0]"
							class="faq-item">
							<summary>{{ faq[0] }}</summary>
							<p>{{ faq[1] }}</p>
						</details>
					</div>
				</div>
			</section>

			<section class="content-section muted">
				<div class="page-shell">
					<h2>
						About
						<a :href="homeUrl">{{ brand }}</a>
					</h2>
					<p>This website provides information, guides, and APK details about GB WhatsApp. We are not the official developer of GB WhatsApp and are not connected with WhatsApp or Meta.</p>
					<p>Our goal is to share useful information about available versions, features, updates, and installation methods to help users better understand the application.</p>
					<p>Users should always review APK sources and device permissions before installing any third-party application.</p>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import downIcon from '@/assets/down-black.svg'
import heroImage from '@/assets/hero-right.png'
import androidImage from '@/assets/home-android-compat.svg'
import overviewImage from '@/assets/home-whatsapp-overview.svg'
import { SITE_BRAND, SITE_HOME_URL } from '@/config/site'
import '@/css/base.scss'

export default {
	name: 'Home',
	components: {
		HeadNav,
	},
	data() {
		return {
			downIcon,
			heroImage,
			androidImage,
			overviewImage,
			brand: SITE_BRAND,
			homeUrl: SITE_HOME_URL,
			heroBadges: [
				{
					icon: 'android',
					title: 'Android',
					text: 'APK',
				},
				{
					icon: 'shield',
					title: 'Anti-Ban',
					text: 'Support',
				},
				{
					icon: 'refresh',
					title: 'Updated',
					text: 'Regularly',
				},
				{
					icon: 'lock',
					title: 'More Privacy',
					text: 'More Control',
				},
			],
			heroStats: [
				{
					icon: 'download',
					label: 'Latest Version',
					value: 'v18.80',
				},
				{
					icon: 'calendar',
					label: 'Updated',
					value: 'May 2026',
				},
				{
					icon: 'phone',
					label: 'Platform',
					value: 'Android',
				},
			],
			apkInformationRows: [
				['App Name', 'GB WhatsApp'],
				['Latest Version', 'v18.80'],
				['File Size', '80 MB'],
				['Android Version', 'Android 5.0 and above'],
				['File Type', 'APK File'],
				['Last Updated', 'May 2026'],
			],
			compatibilityRows: [
				['Operating System', 'Android 5.0 or higher'],
				['Storage', 'Enough space for APK installation'],
				['Internet', 'Required for setup and updates'],
				['Root Access', 'Not required'],
			],
			comparisonRows: [
				['App Type', 'Modified WhatsApp APK', 'Official messaging app'],
				['Platform', 'Android APK', 'Android, iOS, Web'],
				['Themes', 'Supports additional themes and appearance changes', 'Limited appearance customization'],
				['Chat Customization', 'More options for fonts, colors, and layouts', 'Standard chat design'],
				['Privacy Options', 'Includes additional privacy-related settings in some versions', 'Standard privacy controls'],
				['Message Options', 'Extra messaging options may be available', 'Standard messaging features'],
				['Media Sharing', 'Some versions provide additional media settings', 'Standard file sharing limits'],
				['Account Support', 'Some versions support multiple accounts', 'Supports official account features'],
				['Updates', 'Updated through APK versions', 'Updated through official app stores'],
				['Developer Support', 'Community-developed modified versions', 'Developed by WhatsApp / Meta'],
			],
			versionHistoryRows: [
				['v18.70', '2026', '78 MB'],
				['v18.60', '2026', '70 MB'],
				['v18.00', '2025', '68 MB'],
				['v17.85', '2025', '68 MB'],
				['v17.60', '2024', '68 MB'],
			],
			featureRows: [
				{
					title: 'Custom Themes',
					text: 'Change the app appearance with different themes, colors, and visual styles to personalize the interface.',
					mark: 'CT',
					icon: 'icon-theme',
				},
				{
					title: 'Hide Online Status',
					text: 'Customize privacy settings by controlling when your online status is visible to other users.',
					mark: 'OS',
					icon: 'icon-status',
				},
				{
					title: 'Message Privacy Options',
					text: 'Manage additional privacy preferences for chats and conversations with extra control settings.',
					mark: 'MP',
					icon: 'icon-privacy',
				},
				{
					title: 'Anti-Delete Messages',
					text: 'Keep access to some deleted messages inside conversations depending on the available version features.',
					mark: 'DM',
					icon: 'icon-message',
				},
				{
					title: 'Anti-Delete Status',
					text: 'View some status updates even after they are removed by the original sender.',
					mark: 'DS',
					icon: 'icon-status-delete',
				},
				{
					title: 'Advanced Media Sharing',
					text: 'Share photos, videos, and files with additional customization options for media handling.',
					mark: 'MS',
					icon: 'icon-media',
				},
				{
					title: 'Larger File Sharing',
					text: 'Some versions support sharing larger media files compared with standard WhatsApp limitations.',
					mark: 'LF',
					icon: 'icon-file',
				},
				{
					title: 'Chat Customization',
					text: 'Customize chat screens, fonts, colors, and conversation appearance based on personal preferences.',
					mark: 'CC',
					icon: 'icon-chat',
				},
				{
					title: 'Font Styles',
					text: 'Change text styles and personalize the way messages appear in conversations.',
					mark: 'Aa',
					icon: 'icon-font',
				},
				{
					title: 'App Lock',
					text: 'Add an extra lock option to help protect access to the application.',
					mark: 'AL',
					icon: 'icon-lock',
				},
				{
					title: 'Multiple Account Support',
					text: 'Use more than one WhatsApp account option on the same device with supported versions.',
					mark: 'MA',
					icon: 'icon-account',
				},
				{
					title: 'Backup and Restore Options',
					text: 'Manage chat data when updating or reinstalling the application.',
					mark: 'BR',
					icon: 'icon-backup',
				},
			],
			faqRows: [
				['Where Can I Download the Latest GB WhatsApp APK File?', 'You can download the latest GB WhatsApp APK file from this website. Check the version information and APK details before installing the file on your Android device.'],
				['Why Is My GB WhatsApp APK Not Installing on My Android Phone?', 'The installation may fail because of incorrect settings, insufficient storage, or an unsupported Android version. Check that unknown app installation is allowed and try downloading the APK file again.'],
				['Can I Transfer My WhatsApp Chats to GB WhatsApp?', 'Some users can transfer chat data by creating a backup before installation. The available restore options may depend on your device, WhatsApp version, and backup settings.'],
				['Does GB WhatsApp Work Without Root?', 'Yes, GB WhatsApp APK is designed to work on standard Android devices without root access. However, device settings and Android versions may affect installation.'],
				['Do I Need to Uninstall WhatsApp Before Installing GB WhatsApp?', 'In some cases, users may install GB WhatsApp without removing the original app. However, using two apps with the same phone number may cause conflicts depending on the setup.'],
				['Will My WhatsApp Account Get Banned When Using GB WhatsApp?', 'Modified apps may have different risks compared with official applications. Users should understand the possible risks and use APK files carefully.'],
			],
		}
	},
}
</script>

<style lang="scss" scoped>
.gb-page {
	background: #fbfcfb;
	color: #17211c;
	font-family: 'Lora', Georgia, serif;
	font-size: 17px;
	line-height: 1.68;
	-webkit-font-smoothing: antialiased;
	overflow-x: hidden;
}

.page-shell {
	width: min(1120px, calc(100% - 32px));
	margin: 0 auto;
}

.hero-section {
	position: relative;
	padding: 54px 0 28px;
	background: linear-gradient(180deg, #f8fcfa 0%, #ffffff 72%);
	border-bottom: 1px solid #dfe8e3;
	font-family: Arial, Helvetica, sans-serif;
	overflow: hidden;
}

.hero-section::before {
	content: '';
	position: absolute;
	right: -190px;
	top: -210px;
	width: 540px;
	height: 540px;
	border: 1px solid rgba(16, 174, 99, 0.13);
	border-radius: 50%;
	box-shadow:
		0 0 0 72px rgba(16, 174, 99, 0.045),
		0 0 0 144px rgba(16, 174, 99, 0.035);
	pointer-events: none;
}

.hero-section::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 92px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0), #f4faf7);
	pointer-events: none;
}

.hero-layout {
	position: relative;
	z-index: 1;
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(360px, 0.88fr);
	gap: 24px;
	align-items: center;
	min-height: 420px;
}

.hero-copy p {
	max-width: 560px;
	margin: 18px 0 26px;
	color: #51606b;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 16px;
	line-height: 1.55;
}

.hero-eyebrow {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-height: 30px;
	margin: 0 0 14px;
	padding: 0 15px;
	border-radius: 999px;
	background: #e8f8ee;
	color: #0ca05c;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 13px;
	font-weight: 700;
}

.hero-eyebrow::before {
	content: '';
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: #08c36d;
	box-shadow: 0 0 0 4px rgba(8, 195, 109, 0.12);
}

.hero-copy .hero-eyebrow {
	margin-bottom: 18px;
	color: #0ca05c;
	font-size: 13px;
}

.hero-copy h1,
.hero-subtitle {
	font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
	letter-spacing: -0.02em;
}

.hero-copy h1 {
	margin: 0;
	color: #1a1a1a;
	font-size: clamp(44px, 3.6vw, 56px);
	font-weight: 800;
	line-height: 1.08;
	white-space: nowrap;
}

.hero-subtitle {
	margin: 8px 0 0;
	color: #0f9a4a;
	font-size: clamp(22px, 1.85vw, 28px);
	font-weight: 700;
	line-height: 1.2;
	white-space: nowrap;
}

.hero-actions {
	display: grid;
	gap: 38px;
	justify-items: start;
}

.hero-actions .primary-btn {
	min-width: 320px;
	min-height: 52px;
	padding: 0 28px;
	font-size: 15px;
	letter-spacing: 0.02em;
}

.hero-badges {
	display: grid;
	grid-template-columns: repeat(4, max-content);
	align-items: center;
	gap: 0;
	max-width: 720px;
}

.hero-badge {
	display: flex;
	align-items: center;
	gap: 9px;
	min-height: 34px;
	padding: 0 22px;
	border-right: 1px solid #dce7e2;
	color: #17211c;
	font-family: Arial, Helvetica, sans-serif;
	line-height: 1.15;
}

.hero-badge:first-child {
	padding-left: 0;
}

.hero-badge:last-child {
	padding-right: 0;
	border-right: 0;
}

.hero-badge-icon,
.hero-stat-icon {
	display: inline-grid;
	flex: 0 0 auto;
	place-items: center;
	color: #08a962;
}

.hero-badge-icon {
	width: 28px;
	height: 28px;
}

.hero-badge-icon svg,
.hero-stat-icon svg {
	width: 100%;
	height: 100%;
	fill: currentColor;
}

.hero-badge strong,
.hero-badge small {
	display: block;
	white-space: nowrap;
}

.hero-badge strong {
	color: #26322e;
	font-size: 12px;
	font-weight: 700;
}

.hero-badge small {
	margin-top: 2px;
	color: #51606b;
	font-size: 11px;
}

.hero-visual {
	justify-self: end;
	width: min(100%, 530px);
}

.hero-image-wrap {
	position: relative;
	min-height: 420px;
	display: grid;
	grid-template-columns: minmax(218px, 280px) 148px;
	column-gap: 20px;
	align-items: center;
	justify-content: end;
}

.hero-image-wrap::before {
	content: '';
	position: absolute;
	left: 22%;
	bottom: 18px;
	width: 245px;
	height: 32px;
	transform: translateX(-50%);
	border-radius: 50%;
	background: rgba(18, 48, 39, 0.12);
	filter: blur(8px);
	pointer-events: none;
}

.hero-phone-panel {
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	width: min(255px, 100%);
	padding: 18px 16px;
	border-radius: 28px;
	background: #ffffff;
	box-shadow: 0 16px 32px rgba(24, 38, 33, 0.08);
	overflow: hidden;
}

.hero-phone-image {
	width: 100%;
	height: auto;
	display: block;
	filter: drop-shadow(0 20px 24px rgba(13, 28, 24, 0.16));
}

.hero-stats {
	position: relative;
	z-index: 3;
	display: grid;
	gap: 14px;
	width: 148px;
}

.hero-stat-card {
	display: grid;
	grid-template-columns: 30px minmax(0, 1fr);
	align-items: center;
	gap: 9px;
	min-height: 68px;
	padding: 10px 12px;
	border: 1px solid #e7eeea;
	border-radius: 8px;
	background: #ffffff;
	font-family: Arial, Helvetica, sans-serif;
	box-shadow: 0 12px 26px rgba(24, 38, 33, 0.09);
}

.hero-stat-icon {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: #09a860;
	color: #ffffff;
	padding: 7px;
}

.hero-stat-text {
	min-width: 0;
}

.hero-stat-text span,
.hero-stat-text strong {
	display: block;
}

.hero-stat-text span {
	margin-bottom: 3px;
	color: #647067;
	font-size: 10px;
	font-weight: 700;
	line-height: 1.2;
}

.hero-stat-text strong {
	color: #1f2328;
	font-size: 16px;
	font-weight: 800;
	line-height: 1.18;
}

@media (max-width: 1180px) {
	.hero-layout {
		grid-template-columns: minmax(0, 1fr) minmax(388px, 0.76fr);
		gap: 24px;
	}

	.hero-visual {
		width: min(100%, 470px);
	}

	.hero-image-wrap {
		grid-template-columns: minmax(206px, 240px) 136px;
		column-gap: 14px;
	}

	.hero-phone-panel {
		width: min(238px, 100%);
	}

	.hero-stats {
		width: 136px;
	}

	.hero-stat-card {
		grid-template-columns: 28px minmax(0, 1fr);
		gap: 8px;
		padding: 9px 10px;
	}

	.hero-stat-icon {
		width: 28px;
		height: 28px;
	}
}

h1,
h2,
h3 {
	margin: 0;
	color: #1f2328;
	font-family: 'Oswald', Arial, sans-serif;
	font-weight: 400;
	line-height: 1.25;
}

h1 {
	max-width: 760px;
	font-size: clamp(36px, 4vw, 54px);
	line-height: 1.12;
}

.title-line {
	display: block;
}

h2 {
	margin-bottom: 16px;
	font-size: clamp(26px, 2.4vw, 32px);
}

/* Hero 标题不被全局 Oswald 覆盖 */
.hero-section .hero-copy h1,
.hero-section .hero-subtitle {
	font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.hero-section .hero-copy h1 {
	color: #1a1a1a;
	font-size: clamp(44px, 3.6vw, 56px);
	font-weight: 800;
	line-height: 1.08;
}

.hero-section .hero-subtitle {
	margin: 8px 0 0;
	color: #0f9a4a;
	font-size: clamp(22px, 1.85vw, 28px);
	font-weight: 700;
	line-height: 1.2;
}

h2 + h2 {
	margin-top: 38px;
}

h3 {
	margin: 26px 0 10px;
	font-size: 22px;
}

p {
	margin: 0 0 16px;
	color: #24292f;
}

a {
	color: #118343;
}

strong {
	font-weight: 700;
}

ul,
ol {
	margin: 0 0 18px;
	padding-left: 24px;
}

ul {
	padding-left: 0;
}

ol {
	margin-left: 0 !important;
}

li + li {
	margin-top: 7px;
}

.primary-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	min-height: 52px;
	padding: 0 24px;
	border-radius: 8px;
	background: #129447;
	color: #ffffff;
	text-decoration: none;
	font-family: 'Oswald', Arial, sans-serif;
	font-size: 15px;
	text-transform: uppercase;
	box-shadow: 0 14px 26px rgba(18, 148, 71, 0.23);
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease,
		background 0.2s ease;
}

.primary-btn:hover {
	transform: translateY(-2px);
	background: #0f7d3d;
	box-shadow: 0 18px 30px rgba(18, 148, 71, 0.28);
}

.btn-icon {
	width: 15px;
	height: 15px;
	filter: brightness(0) invert(1);
}

.content-section {
	padding: 68px 0;
}

.hero-intro-section {
	padding: 42px 0 0;
	background: #ffffff;
}

.hero-intro {
	max-width: min(1120px, calc(100% - 32px));
}

.hero-intro p {
	max-width: 1120px;
	margin: 0 0 12px;
	color: #334139;
	font-family: Arial, sans-serif;
	font-size: 17px;
	line-height: 1.7;
}

.hero-intro p:last-child {
	margin-bottom: 0;
}

.muted {
	background: linear-gradient(180deg, #f5faf7 0%, #f0f7f3 100%);
}

.table-wrap {
	width: 100%;
	margin: 20px 0 24px;
	overflow-x: auto;
	border: 1px solid #d6e1db;
	border-radius: 10px;
	background: #ffffff;
	box-shadow: 0 12px 28px rgba(31, 35, 40, 0.05);
}

table {
	width: 100%;
	border-collapse: collapse;
	color: #111111;
	font-family: Arial, sans-serif;
	font-size: 16px;
	line-height: 1.45;
}

th,
td {
	padding: 14px 16px;
	border-right: 1px solid #e0e7e3;
	border-bottom: 1px solid #e0e7e3;
	text-align: left;
	vertical-align: middle;
}

th:last-child,
td:last-child {
	border-right: 0;
}

tbody tr:last-child td {
	border-bottom: 0;
}

th {
	background: #123027;
	color: #ffffff;
	font-weight: 700;
}

tbody tr:nth-child(even) td {
	background: #f7fbf8;
}

tbody td:first-child {
	color: #123027;
	font-weight: 700;
}

.comparison-table table {
	min-width: 720px;
}

.compat-layout,
.overview-layout {
	display: grid;
	grid-template-columns: minmax(220px, 360px) minmax(0, 1fr);
	gap: 40px;
	align-items: center;
}

.compat-visual,
.overview-visual {
	padding: 14px;
	border: 1px solid #dbe5df;
	border-radius: 12px;
	background: linear-gradient(160deg, #ffffff 0%, #eef8f2 100%);
	box-shadow: 0 14px 30px rgba(31, 35, 40, 0.06);
	overflow: hidden;
}

.compat-visual img,
.overview-visual img {
	width: 100%;
	height: 100%;
	min-height: 280px;
	display: block;
	border-radius: 8px;
	object-fit: cover;
	object-position: center;
	filter: drop-shadow(0 16px 24px rgba(18, 48, 39, 0.12));
}

.install-section {
	background: radial-gradient(circle at 88% 12%, rgba(31, 111, 235, 0.06), transparent 28%), radial-gradient(circle at 8% 88%, rgba(18, 148, 71, 0.08), transparent 32%), linear-gradient(180deg, #ffffff 0%, #f8fbf9 100%);
}

.install-header {
	max-width: 760px;
	margin-bottom: 36px;
}

.install-header p {
	margin-bottom: 0;
}

.install-timeline {
	display: grid;
	gap: 0;
}

.install-step {
	display: grid;
	grid-template-columns: 72px minmax(0, 1fr);
	gap: 24px;
	align-items: start;
}

.step-marker {
	position: relative;
	display: flex;
	justify-content: center;
	padding-top: 28px;
}

.step-marker::after {
	content: '';
	position: absolute;
	top: 76px;
	bottom: -8px;
	left: 50%;
	width: 2px;
	transform: translateX(-50%);
	background: linear-gradient(180deg, #d7e8de 0%, rgba(215, 232, 222, 0.2) 100%);
}

.install-step:last-child .step-marker::after {
	display: none;
}

.install-card,
.feature-card,
.problem-card,
.update-card {
	border: 1px solid #dbe5df;
	border-radius: 14px;
	background: #ffffff;
	box-shadow: 0 12px 28px rgba(31, 35, 40, 0.06);
}

.install-card {
	position: relative;
	margin-bottom: 28px;
	padding: 28px 30px;
	overflow: hidden;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease,
		border-color 0.2s ease;
}

.install-card::before {
	content: '';
	position: absolute;
	inset: 0 auto 0 0;
	width: 5px;
	background: #129447;
}

.install-step.step-2 .install-card::before {
	background: #1f6feb;
}

.install-step.step-3 .install-card::before {
	background: #b7791f;
}

.install-card:hover {
	transform: translateY(-2px);
	border-color: rgba(18, 148, 71, 0.28);
	box-shadow: 0 20px 36px rgba(31, 35, 40, 0.09);
}

.step-num {
	position: relative;
	z-index: 1;
	display: inline-grid;
	place-items: center;
	width: 52px;
	height: 52px;
	border: 4px solid #ffffff;
	border-radius: 50%;
	background: #129447;
	color: #ffffff;
	font-family: 'Oswald', Arial, sans-serif;
	font-size: 16px;
	box-shadow: 0 10px 22px rgba(18, 148, 71, 0.28);
}

.step-2 .step-num {
	background: #1f6feb;
	box-shadow: 0 10px 22px rgba(31, 111, 235, 0.28);
}

.step-3 .step-num {
	background: #b7791f;
	box-shadow: 0 10px 22px rgba(183, 121, 31, 0.28);
}

.install-card h3 {
	margin: 0 0 14px;
	font-size: 24px;
}

.install-card p:last-child,
.install-card ul:last-child,
.install-card ol:last-child {
	margin-bottom: 0;
}

.install-card ul,
.install-card ol {
	padding-left: 22px;
}

.install-card li::marker {
	color: #129447;
	font-weight: 700;
}

.step-2 .install-card li::marker {
	color: #1f6feb;
}

.step-3 .install-card li::marker {
	color: #b7791f;
}

.features-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 18px;
	margin-top: 28px;
}

.feature-card {
	padding: 24px 22px;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease,
		border-color 0.2s ease;
}

.feature-card:hover {
	transform: translateY(-3px);
	border-color: rgba(18, 148, 71, 0.3);
	box-shadow: 0 18px 34px rgba(31, 35, 40, 0.09);
}

.feature-card h3 {
	margin: 0 0 10px;
	font-size: 20px;
}

.feature-card p,
.problem-card p,
.problem-card ul {
	margin-bottom: 0;
}

.feature-mark {
	display: inline-grid;
	place-items: center;
	width: 44px;
	height: 44px;
	margin-bottom: 16px;
	border-radius: 8px;
	color: #ffffff;
	font-family: 'Oswald', Arial, sans-serif;
	font-size: 14px;
}

.icon-theme {
	background: #129447;
}
.icon-status {
	background: #1f6feb;
}
.icon-privacy {
	background: #7c3aed;
}
.icon-message {
	background: #b7791f;
}
.icon-status-delete {
	background: #be123c;
}
.icon-media {
	background: #0f766e;
}
.icon-file {
	background: #4f46e5;
}
.icon-chat {
	background: #0e7490;
}
.icon-font {
	background: #92400e;
}
.icon-lock {
	background: #334155;
}
.icon-account {
	background: #15803d;
}
.icon-backup {
	background: #9333ea;
}

.download-box {
	position: relative;
	padding: 40px 42px;
	border-radius: 12px;
	background: linear-gradient(125deg, #123027 0%, #164c35 55%, #1a5c3f 100%);
	color: #ffffff;
	box-shadow: 0 22px 42px rgba(18, 48, 39, 0.16);
	overflow: hidden;
}

.download-box::after {
	content: '';
	position: absolute;
	right: -40px;
	top: -40px;
	width: 220px;
	height: 220px;
	border-radius: 50%;
	background: rgba(240, 180, 41, 0.16);
	pointer-events: none;
}

.download-box h2,
.download-box p,
.download-box .primary-btn {
	position: relative;
	z-index: 1;
}

.download-box h2,
.download-box p {
	color: #ffffff;
	max-width: 720px;
}

.download-box .primary-btn {
	margin-top: 8px;
	background: #ffffff;
	color: #123027;
	box-shadow: none;
}

.download-box .primary-btn:hover {
	background: #f0f7f3;
}

.download-box .btn-icon {
	filter: none;
}

.update-card {
	margin: 28px 0;
	padding: 28px;
	border-left: 5px solid #129447;
	background: linear-gradient(90deg, rgba(18, 148, 71, 0.04), transparent 40%), #ffffff;
}

.update-card h2 {
	margin-top: 0;
}

.problem-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 18px;
	margin-top: 28px;
}

.problem-card {
	position: relative;
	padding: 24px 22px;
	overflow: hidden;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease;
}

.problem-card::after {
	content: '';
	position: absolute;
	inset: auto 0 0;
	height: 4px;
	background: #129447;
}

.problem-card:nth-child(2)::after {
	background: #b7791f;
}

.problem-card:nth-child(3)::after {
	background: #1f6feb;
}

.problem-card:hover {
	transform: translateY(-3px);
	box-shadow: 0 16px 30px rgba(31, 35, 40, 0.08);
}

.problem-card h3 {
	margin-top: 0;
}

.problem-content h3:first-of-type {
	margin-top: 8px;
}

.faq-list {
	display: grid;
	gap: 12px;
	margin-top: 24px;
}

.faq-item {
	border: 1px solid #dbe5df;
	border-radius: 10px;
	background: #ffffff;
	overflow: hidden;
	box-shadow: 0 8px 18px rgba(31, 35, 40, 0.03);
	transition: border-color 0.2s ease;
}

.faq-item:hover,
.faq-item[open] {
	border-color: rgba(18, 148, 71, 0.35);
}

.faq-item summary {
	position: relative;
	cursor: pointer;
	list-style: none;
	padding: 18px 56px 18px 20px;
	color: #1f2328;
	font-family: 'Oswald', Arial, sans-serif;
	font-size: 19px;
	line-height: 1.35;
}

.faq-item summary::-webkit-details-marker {
	display: none;
}

.faq-item summary::after {
	content: '+';
	position: absolute;
	top: 50%;
	right: 18px;
	width: 28px;
	height: 28px;
	display: grid;
	place-items: center;
	transform: translateY(-50%);
	border-radius: 50%;
	background: #e8f5ed;
	color: #118343;
	font-family: Arial, sans-serif;
}

.faq-item[open] summary::after {
	content: '-';
}

.faq-item p {
	margin: 0;
	padding: 0 20px 20px;
}

@media (max-width: 1100px) {
	.compat-layout,
	.overview-layout,
	.features-grid {
		grid-template-columns: 1fr;
	}

	.compat-visual,
	.overview-visual {
		width: min(100%, 420px);
		justify-self: start;
	}
}

@media (max-width: 940px) {
	.hero-layout {
		grid-template-columns: 1fr;
	}

	.hero-visual {
		width: min(100%, 520px);
		justify-self: center;
	}

	.hero-image-wrap {
		justify-content: center;
	}
}

@media (max-width: 820px) {
	.page-shell {
		width: min(1120px, calc(100% - 32px));
	}
}

@media (max-width: 620px) {
	.gb-page {
		font-size: 16px;
	}

	.hero-section {
		padding: 36px 0 42px;
	}

	.hero-layout {
		gap: 28px;
		min-height: 0;
	}

	.hero-copy {
		min-width: 0;
		width: min(100%, calc(100vw - 32px));
		max-width: calc(100vw - 32px);
	}

	.install-step {
		grid-template-columns: 56px minmax(0, 1fr);
		gap: 16px;
	}

	.step-marker {
		padding-top: 22px;
	}

	.step-num {
		width: 44px;
		height: 44px;
		font-size: 14px;
	}

	.install-card {
		padding: 22px 18px;
	}

	.install-card h3 {
		font-size: 20px;
	}

	.hero-copy p {
		width: 100%;
		max-width: min(100%, 320px);
		font-size: 16px;
		word-break: normal;
	}

	.hero-section .hero-copy h1 {
		max-width: 100%;
		font-size: clamp(32px, 8vw, 44px);
		white-space: normal;
		word-break: normal;
		overflow-wrap: anywhere;
	}

	.hero-section .hero-subtitle {
		max-width: 100%;
		font-size: clamp(20px, 5.2vw, 24px);
		white-space: normal;
		word-break: normal;
		overflow-wrap: anywhere;
	}

	.content-section {
		padding: 48px 0;
	}

	.primary-btn {
		width: 100%;
	}

	.hero-actions,
	.hero-badges {
		width: 100%;
	}

	.hero-image-wrap {
		grid-template-columns: minmax(0, 1fr);
		justify-items: center;
		min-height: 0;
		row-gap: 16px;
	}

	.hero-image-wrap::before {
		left: 50%;
		bottom: 116px;
		width: min(245px, 70vw);
	}

	.hero-phone-panel {
		width: min(245px, 75vw);
	}

	.hero-badges {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		row-gap: 18px;
	}

	.hero-badge {
		padding: 0 14px 0 0;
		border-right: 0;
	}

	.hero-badge:nth-child(even) {
		padding-left: 14px;
		border-left: 1px solid #dce7e2;
	}

	.hero-stats {
		position: relative;
		top: auto;
		right: auto;
		width: min(100%, 360px);
		grid-template-columns: 1fr;
		margin-top: 16px;
	}

	.download-box {
		padding: 28px 20px;
	}

	.install-card,
	.feature-card,
	.problem-card,
	.update-card {
		padding: 20px;
	}

	table {
		font-size: 15px;
	}
}
</style>
